/**
 * Convert any raw status coming from Mongo
 *   →  "CONFIRMED" | "PREPARING" | "DONE"
 */
export const bucketOf = (statusName = '') => {
  switch (String(statusName).toUpperCase()) {
    case 'PENDING':
    case 'PLACED':
    case 'ACCEPT':
      return 'CONFIRMED';

    case 'PROCESSING':
    case 'PREPARING':
      return 'PREPARING';

    default:  // OUT_FOR_DELIVERY, DELIVERED, etc.
      return 'DONE';
  }
};
